import { createTheme } from "@mui/material";

const theme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "100% !important",
          padding: 20,
        },
      },
    },
  },
});

export default theme;
